import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useInvoiceIssuesContextValue } from '../context/InvoiceIssuesProvider'

export const InvoiceIssuesHeader = () => {
  const { state, actions } = useInvoiceIssuesContextValue()

  return (
    <Header
      title="Invoice Issues"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
